import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';


// Authenticated pages
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));
const RecordsPage = lazy(() => import('../pages/weighbridge/RecordsPage'));
const Compost = lazy(() => import('../pages/compost/Compost'));
const Hybrid = lazy(() => import('../pages/hybrid/Hybrid'));
const Transfers = lazy(() => import('../pages/transfers/Transfers'));
const ProtectedRoute = lazy(() => import('./ProtectedRoute'));
const TicketsPage = lazy(() => import('../pages/weighbridge/TicketsPage'));
const authenticatedRoutes = [
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/weighbridge',
    element: (
      <ProtectedRoute>
        <TicketsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/compost',
    element: (
      <ProtectedRoute>
        <Compost />
      </ProtectedRoute>
    ),
  },
  {
    path: '/hybrid',
    element: (
      <ProtectedRoute>
        <Hybrid />
      </ProtectedRoute>
    ),
  },
  {
    path: '/transfers',
    element: (
      <ProtectedRoute>
        <Transfers />
      </ProtectedRoute>
    ),
  },

    {
    path: '/weighbrige-records/:providerId',
    element: (
      <ProtectedRoute>
        <RecordsPage />
      </ProtectedRoute>
    ),
  },

  {
    path: '/weighbridge',
    element: (
      <ProtectedRoute>
        <TicketsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    ),
  },

  
];

export default authenticatedRoutes;

